module.exports = __webpack_public_path__ + "static/media/get_from_ms.c62abca7.png";